/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

import Context from "shared/util/Context";

window.Localization = {
	ws: /\s+/g,

	setStrings(strings) {
		let STRINGS;
		if (!STRINGS) {
			window.STRINGS = [];
		}

		return (STRINGS = STRINGS.concat(strings));
	},

	cleanKey(key) {
		if (!key) {
			return key;
		}
		key = key.replace(this.ws, " ");
		key = key.trim();
		return key;
	},

	_returnString(string) {
		if (Context.get("localizationDebug")) {
			return `☃${string}☃`;
		} else {
			return string;
		}
	},

	string(key) {
		key = this.cleanKey(key);
		let string =
			(typeof STRINGS !== "undefined" && STRINGS !== null
				? STRINGS[key]
				: undefined) ||
			key ||
			"";
		return this._returnString(string);
	},

	stringIfExist(key) {
		key = this.cleanKey(key);
		let string =
			(typeof STRINGS !== "undefined" && STRINGS !== null
				? STRINGS[key]
				: undefined) || null;
		return this._returnString(string);
	},

	stringWithFormat(base, replacements) {
		// if you substantially change this, also make those changes to
		// util/components/Strf!

		if (!base) {
			return "";
		}
		let str = this.string(base);

		if (!replacements) {
			return str;
		}

		// since the first key is "1", and arrays are zero-indexed,
		// prepend the replacements field with a dummy entry
		if (Array.isArray(replacements)) {
			replacements = [""].concat(replacements);
		}

		return str.replace(/\$(\d+|\w+)/g, function(match, p1) {
			let repl = replacements[p1];
			if (repl === null) {
				return "";
			} else {
				return repl;
			}
		});
	},
};

// aliases
window._str = str => window.Localization.string(str);

window._strf = (str, replacements) =>
	window.Localization.stringWithFormat(str, replacements);



// WEBPACK FOOTER //
// ./src/legacy/localization.js